export default __webpack_public_path__ + "static/media/CamTerminologyImg.d6e5c58c.jpg";